import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Button, Modal, Form, Input, message, Pagination } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { SidebarLayout } from '../components/SidebarLayout';
import axios from 'axios';

const api = `${process.env.REACT_APP_API_URL}/device_status`;

const DeviceStatusForm = ({ visible, onCancel, onSubmit, initialValues }) => {
  const [form] = Form.useForm();
  useEffect(() => {
    if (visible) form.setFieldsValue(initialValues || {}); else form.resetFields();
  }, [visible, initialValues]);
  return (
    <Modal
      open={visible}
      title={initialValues ? 'Editar Status' : 'Novo Status'}
      onCancel={onCancel}
      onOk={() => {
        form.validateFields()
          .then(values => {
            form.resetFields();
            onSubmit(values);
          });
      }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="dsname"
          label="Nome do Status"
          rules={[
            { required: true, message: 'Nome do status é obrigatório' },
            { max: 100, message: 'Máximo de 100 caracteres' }
          ]}
        >
          <Input maxLength={100} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export const DeviceStatus = () => {
  const [statuses, setStatuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingStatus, setEditingStatus] = useState(null);
  const [formVisible, setFormVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [messageApi, contextHolder] = message.useMessage();
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 8;

  const fetchStatuses = async () => {
    setLoading(true);
    try {
      const res = await axios.get(api);
      setStatuses(res.data);
    } catch {
      messageApi.error('Erro ao buscar status');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchStatuses();
  }, []);

  const handleCreate = async values => {
    try {
      await axios.post(api, values);
      messageApi.success('Status criado com sucesso');
      fetchStatuses();
    } catch (error) {
      var apiMsg = 'Erro ao criar status';
      if (error.response?.status != 500) {
        apiMsg +=  ': ' + error.response?.data?.error || '!';
      }
      messageApi.error(apiMsg);
    }
    setFormVisible(false);
  };

  const handleUpdate = async values => {
    try {
      await axios.put(`${api}/${editingStatus.id}`, values);
      messageApi.success('Status atualizado com sucesso');
      fetchStatuses();
    } catch (error) {
      var apiMsg = 'Erro ao atualizar status';
      if (error.response?.status != 500) {
        apiMsg +=  ': ' + error.response?.data?.error || '!';
      }
      messageApi.error(apiMsg);
    }
    setEditingStatus(null);
    setFormVisible(false);
  };

  const handleDelete = id => {
    Modal.confirm({
      title: 'Tem certeza que deseja remover este status?',
      content: 'Esta ação não poderá ser desfeita.',
      okText: 'Sim, remover',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: async () => {
        try {
          await axios.delete(`${api}/${id}`);
          messageApi.success('Status removido com sucesso');
          fetchStatuses();
        } catch (error) {
          var apiMsg = 'Erro ao remover status';
          if (error.response?.status != 500) {
            apiMsg +=  ': ' + error.response?.data?.error || '!';
          }
          messageApi.error(apiMsg);
        }
      }
    });
  };

  const filteredStatuses = statuses.filter(status =>
    status.dsname?.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <SidebarLayout>
      {contextHolder}
      <div style={{ padding: 24 }}>
        <h1>Status dos Dispositivos</h1>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setEditingStatus(null);
              setFormVisible(true);
            }}
          >
            Novo Status
          </Button>
          <Input.Search
            placeholder="Buscar status"
            allowClear
            onSearch={value => setSearchText(value)}
            onChange={e => setSearchText(e.target.value)}
            style={{ width: 300 }}
          />
        </div>

        <Row gutter={[42, 32]}>
          {filteredStatuses
            .slice((currentPage - 1) * pageSize, currentPage * pageSize)
            .map(status => (
              <Col xs={24} sm={12} md={8} lg={8} key={status.id}>
                <Card
                  actions={[
                    <EditOutlined key="edit" onClick={() => { setEditingStatus(status); setFormVisible(true); }} />,
                    <DeleteOutlined key="delete" style={{ color: 'red' }} onClick={() => handleDelete(status.id)} />
                  ]}
                  style={{ boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)', padding: 0 }}
                >
                  
                  <p><b>Nome:</b> {status.dsname}</p>
                </Card>
              </Col>
            ))}
        </Row>

        <div style={{ marginTop: 24, display: 'flex', justifyContent: 'end' }}>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={filteredStatuses.length}
            onChange={page => setCurrentPage(page)}
            showSizeChanger={false}
          />
        </div>

        <DeviceStatusForm
          visible={formVisible}
          onCancel={() => setFormVisible(false)}
          onSubmit={editingStatus ? handleUpdate : handleCreate}
          initialValues={editingStatus}
        />
      </div>
    </SidebarLayout>
  );
};
